export default __webpack_public_path__ + "static/media/closed-it.f880ab39.png";